import React, { useEffect } from 'react';
import ModalNavigationGuard from './ModalNavigationGuard';
import { usePrompt } from '../hooks/usePrompt';

type NavigationGuardProps = {
  headingModal: string;
  contentModal: string;
};

const NavigationGuard: React.FC<NavigationGuardProps> = ({
  headingModal, contentModal,
}: NavigationGuardProps) => {
  const { showPrompt, confirmNavigation, cancelNavigation } = usePrompt();

  const handleClickNo = (): void => {
    cancelNavigation();
  };

  const handleClickYes = (): void => {
    window.parent.postMessage({
      type: 'block-navigate',
      value: false,
    }, '*');
    confirmNavigation();
  };

  useEffect(() => {
    if (showPrompt) {
      window.parent.postMessage({
        type: 'iframe-to-parent-modal-dialogue-open',
      }, '*');
    } else {
      window.parent.postMessage({
        type: 'iframe-to-parent-modal-dialogue-close',
      }, '*');
    }
  }, [showPrompt]);

  return (
    <ModalNavigationGuard
      visible={showPrompt}
      onCancel={handleClickNo}
      onConfirm={handleClickYes}
      headingModal={headingModal}
      contentModal={contentModal}
    />
  );
};

export default NavigationGuard;
